import { Grid, Switch } from "@material-ui/core";
import { InfoTwoTone } from "@material-ui/icons";
import _, { cloneDeep } from "lodash";
import moment from "moment";
import {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useLocation, useParams } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import SwipeableViews from "react-swipeable-views";
import { v4 as uuidv4 } from "uuid";
import CustomTabs from "../../../common/Tabs";
import AccountCargoDetails from "../../../components/Calculator/AccountCargoDetails";
import ActionButtons from "../../../components/Calculator/ActionButtons";
import VesselContractForm from "../../../components/Calculator/AddCalculatorFleet/createVesselContractModel";
import BunkerSupplyMarginAllowance from "../../../components/Calculator/BunkerSupplyMarginAllowancesTable";
import CalculatorVesselDetails from "../../../components/Calculator/CalculatorVesselDetails";
import DailyExpensesModal from "../../../components/Calculator/DailyExpensesModal";
import Expenses from "../../../components/Calculator/Expenses";
import MarginAndAllowances from "../../../components/Calculator/MarginAndAllowances";
import MarginAllowancesTable from "../../../components/Calculator/MarginAllowancesTable";
import PortOperations from "../../../components/Calculator/PortOperations";
import Result from "../../../components/Calculator/Result";
import SplitHireModal from "../../../components/Calculator/SplitHireModal";
import CustomAddModal from "../../../components/Common/CustomAddModal";
import CustomConfirmModal from "../../../components/Common/CustomConfirmModal";
import CustomShowModal from "../../../components/Common/CustomShowModal";
import {
  initialCreatePortOperation,
  termsCoEfficientTable,
} from "../../../constants";
import {
  getCurrentUserId,
  getOrganizationId,
  toastError,
  toastSuccess,
} from "../../../utils";
import * as calculationAction from "../Calculator/actions";
import {
  initialContractFields,
  initialVesselContractFields,
} from "../Calculator/Contracts";
import {
  addPortDistanceToOperations,
  addPortDistanceToSelectedFleet,
  calculationValidation,
  convertPortOperationToDistanceString,
  fleetWithCalculatorDataMapping,
  placeAddedOperation,
} from "../Calculator/dataMapping";
import CreateCargoContractForm from "../Orders/createCargoContractModel";
import { getOperationById } from "./action";

export default function SavedContracts(props) {
  const fetchPortDistance = useRef(true);
  const swipeableActions = useRef(null);
  const {
    id = "",
    setIsFullScreen = () => { },
    isRevised = false,
    setIsRevised = () => { },
    loader = false,
    setLoader = () => { },
    tabs: propsTabs = [],
    active = 0,
    handleMainTabChange = () => { },
  } = props;
  const { id: routeId = "", queryid = "", vesselid = "" } = useParams();
  const isFromSavedContracts = window.location.pathname.includes('/saved-revised-contracts/') || props?.id !== "" || false;
  const location = useLocation();
  const organizationId = getOrganizationId();
  const [calculatorData, setCalculatorData] = useState({
    portOperation: [],
    fleetList: [],
    clientQuery: {},
  });
  const [selectedVessels, setSelectedVessels] = useState({});
  const [inputValue, setInputValue] = useState();
  const [portDistanceResponse, setPortDistanceResponse] = useState({});
  const [realPortDistanceResponse, setRealPortDistanceResponse] = useState({});
  const [portDistancePayloadResponse, setPortDistancePayloadResponse] = useState({});
  const [prevAttachments, setPrevAttachments] = useState({
    attachments: [],
    textContract: "",
  });
  const [cargoTextContract, setCargoTextContract] = useState(null);
  const [vesselTextContract, setVesselTextContract] = useState(null);
  const [rawEstimateContract, setRawEstimateContract] = useState({});
  const [syncBunker, setSyncBunker] = useState(false);
  const [cargoFormData, setCargoFormData] = useState(initialContractFields);
  const [vesselFormData, setVesselFormData] = useState(
    initialVesselContractFields
  );
  const [estimationCopyModelOpen, setEstimationCopyModelOpen] = useState(false);
  const [editCargoContractModelOpen, setEditCargoContractModelOpen] =
    useState(false);
  const [editVesselContractModelOpen, setEditVesselContractModelOpen] =
    useState(false);
  const [supplyModal, setSupplyModal] = useState(false);
  const [isOverride, setIsOverride] = useState(false);
  const [openAddOperation, setOpenAddOperation] = useState(false);
  const [splitHireModal, setSplitHireModal] = useState(false);
  const [cargoAttachments, setCargoAttachments] = useState([]);
  const [vesselAttachments, setVesselAttachments] = useState([]);
  const [openAddOperationIndex, setOpenAddOperationindex] = useState(false);
  const [IsEditable, setIsEditable] = useState(false);
  const [showExpensesModal, setShowExpensesModal] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(false);
  const history = useHistory();
  const [showSaveWarningModal, setShowSaveWarningModal] = useState(false);
  const [marginModal, setMarginModal] = useState(false);


  const [fleetCheckbox, setFleetCheckbox] = useState({
    ballest: {
      1: true,
      2: true,
      3: true,
      4: true,
    },
    laden: {
      1: true,
      2: true,
      3: true,
      4: true,
    },
  });
  const delayUpdateAndSaveOperation = useCallback(
    _.debounce((data) => onUpdateAndSavePortDistance(data), 500),
    []
  );
  const onChangeClientQuery = (e) => {
    const { name = "", value = "" } = e.target || {};
    let updatedClientQuery = { ...calculatorData.clientQuery };
    if (updatedClientQuery.customerCargo) {
      updatedClientQuery.customerCargo = {
        ...updatedClientQuery.customerCargo,
        [name]: value,
      };
    } else {
      updatedClientQuery[name] = value;
    }
    setCalculatorData({
      ...calculatorData,
      clientQuery: updatedClientQuery,
    });
  };
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    if (swipeableActions.current) {
      setTimeout(() => {
        if (swipeableActions.current) {
          swipeableActions.current.updateHeight();
        }
      }, 100);
    }
  }, [calculatorData.portOperation, activeTab]);

  const tabs = ["Port Operations", "Bunker & Margin Allowance"];

  const handleTabChange = (index) => {
    setActiveTab(index);
  };

  const handleSwipeChange = (index) => {
    setActiveTab(index);
  };

  useEffect(() => {
    setIsFullScreen(true);
    // getInitalQueryAndFleetData(queryid, vesselid)
    if (id || routeId) {
      getInitialData(id || routeId);
    }
    return () => {
      setIsFullScreen(false);
    };
  }, []);
  const getInitialData = async (id) => {
    setLoader(true, "Fetching data...");
    getOperationById({ id })
      .then(async (res) => {
        setIsEditable(res.data.operationAccess === "private");
        await setRawEstimateContract(res?.data);
        const clientQuery = res.data?.cargoContractDetails?.cargoDetails;
        if (clientQuery) {
          if (clientQuery.customerCargo?.portToPortDistanceReal) {
            clientQuery.portToPortDistanceReal = clientQuery.customerCargo.portToPortDistanceReal;
          }
          if (clientQuery.customerCargo?.portToPortDistance) {
            clientQuery.portToPortDistance = clientQuery.customerCargo.portToPortDistance;
          }
        }
        const cargoList = clientQuery?.customerCargo?.cargoList || clientQuery?.cargoList;
        const calculatorResult = res.data?.vesselContractDetails?.vesselDetails;
        const portOperation = cargoList.map((item, index) => ({
          ...item,
          index,
        }));

        await sendCalculationRequest({
          portOperation: portOperation,
          fleetList: [calculatorResult],
          clientQuery: clientQuery,
          autoSave: false,
        });
        setIsInitialLoad(true);
      })
      .catch((err) => {
        setLoader(false);
      }).finally(() => {
        setLoader(false);
      });
  };

  useEffect(() => {
    if (isInitialLoad && new URLSearchParams(location?.search)?.get("code"))
      onClickCalculateAndSave().then(() => {
        history.replace(`${location.pathname}`);
      });
  }, [isInitialLoad]);

  const splitHireArray = calculatorData.fleetList?.[0]?.splitHire
    ? JSON.parse(calculatorData.fleetList[0].splitHire)
    : [{ hireRate: "", NoDays: "" }];

  const onChangeSplitHire = (index, e, isDelete = false) => {
    let updatedSplitHire = [...splitHireArray];

    if (isDelete) {
      updatedSplitHire = updatedSplitHire.filter((_, i) => i !== index);
    } else {
      const { name, value } = e.target;
      updatedSplitHire[index][name] = value;
    }

    setCalculatorData((prev) => ({
      ...prev,
      fleetList: prev.fleetList.map((item, i) =>
        i === 0
          ? { ...item, splitHire: JSON.stringify(updatedSplitHire) }
          : item
      ),
    }));
  };

  const addRow = () => {
    const newRow = { hireRate: "", NoDays: "", applied: 0, disable: false };
    setCalculatorData((prev) => ({
      ...prev,
      fleetList: prev.fleetList.map((item, i) =>
        i === 0
          ? {
            ...item,
            splitHire: JSON.stringify([...splitHireArray, newRow]),
          }
          : item
      ),
    }));
  };

  const onChangeSelectedVessel = (e, isFleetEdit = false) => {
    const {
      name = "",
      value = "",
      type = "number",
      checked = false,
    } = e.target || {};
    let newUpdatedFleet = { ...selectedVessels };
    const { fuelType = "" } = calculatorData.clientQuery || {};
    let updatedvessel = { ...JSON.parse(newUpdatedFleet.vessel) };

    if (isFleetEdit) {
      newUpdatedFleet[name] = value;
    } else {
      if (type === "checkbox") {
        updatedvessel[name] = checked;
        if (
          name === "vesselBalComb1Selected" ||
          name === "vesselBalComb2Selected" ||
          name === "vesselBalComb3Selected" ||
          name === "vesselBalComb4Selected"
        ) {
          if (
            !updatedvessel["vesselBalComb1Selected"] &&
            !updatedvessel["vesselBalComb2Selected"] &&
            !updatedvessel["vesselBalComb3Selected"] &&
            !updatedvessel["vesselBalComb4Selected"]
          ) {
            return;
          }
        } else if (
          name === "vesselLadComb1Selected" ||
          name === "vesselLadComb2Selected" ||
          name === "vesselLadComb3Selected" ||
          name === "vesselLadComb4Selected"
        ) {
          if (
            !updatedvessel["vesselLadComb1Selected"] &&
            !updatedvessel["vesselLadComb2Selected"] &&
            !updatedvessel["vesselLadComb3Selected"] &&
            !updatedvessel["vesselLadComb4Selected"]
          ) {
            return;
          }
        }
      } else {
        updatedvessel[name] = value;
      }
    }
    const updatedFleet = {
      ...newUpdatedFleet,
      vessel: JSON.stringify(updatedvessel),
    };
    setSelectedVessels(updatedFleet);
    const updatedFleetList = calculatorData.fleetList.map((item) => {
      if (item._id === updatedFleet._id) {
        return updatedFleet;
      }
      return item;
    });
    let updatedPortOperation = [...calculatorData.portOperation];
    if (
      name === "bnkPriceDeliveryhs" ||
      name === "bnkPriceDeliveryls" ||
      name === "bnkPriceDeliverymgo"
    ) {
      const currentType = fuelType.replace("TYPE", "");
      if (name === "bnkPriceDeliveryhs")
        updatedPortOperation[0].cargoDetails[
          `fuelPriceType${currentType}Hsfo`
        ] = value;
      if (name === "bnkPriceDeliveryls")
        updatedPortOperation[0].cargoDetails[
          `fuelPriceType${currentType}Lsfo`
        ] = value;
      if (name === "bnkPriceDeliverymgo")
        updatedPortOperation[0].cargoDetails[`fuelPriceType${currentType}Mgo`] =
          value;
    }
    if (name === "bnkDelhs" || name === "bnkDells" || name === "bnkDelmgo") {
      if (updatedPortOperation.length) {
        if (name === "bnkDelhs")
          updatedPortOperation[0].cargoDetails.bunkerSuppliedHSFO = value;
        if (name === "bnkDells")
          updatedPortOperation[0].cargoDetails.bunkerSuppliedLSFO = value;
        if (name === "bnkDelmgo")
          updatedPortOperation[0].cargoDetails.bunkerSuppliedMGO = value;
      }
    }
    setCalculatorData({
      ...calculatorData,
      portOperation: updatedPortOperation,
      fleetList: updatedFleetList,
    });
  };

  const onUpdateAndSavePortDistance = ({
    updateData = {},
    saveData = {},
    updatedCalculatorData = {},
  }) => {
    setLoader(true, "Saving port distance details...");
    Promise.all([
      // calculationAction.updateDistance(updateData),
      calculationAction.savePortDistance(saveData),
    ])
      .then(() => {
        setLoader(false);
        sendCalculationRequest(updatedCalculatorData);
      })
      .catch((err) => {
        setLoader(false);
        toastError(err?.data?.message || "Something went wrong.");
      });
  };
  const onFetchAndSetIntitalPortDistance = (propCalculator) => {
    if (!fetchPortDistance.current) return;
    let updatedCalculatorData = { ...propCalculator };
    const { getPortDistanceString, routeList } =
      convertPortOperationToDistanceString(updatedCalculatorData);
    setLoader(true, "Calculating port distances...");

    return new Promise((resolve, reject) => {
      const { clientQuery = {} } = updatedCalculatorData;
      const {
        eca = false,
        hra = false,
        jwc = false,
        suez = false,
        panama = false,
        singapore = false,
      } = clientQuery;
      const portDataObj = {
        eca,
        hra,
        jwc,
        suez,
        panama,
        singapore,
        routeOverride: false,
        routeList: routeList,
        portList: getPortDistanceString,
        contractId: id || routeId,
        queryId: updatedCalculatorData?.clientQuery?._id,
        getGeometry: false,
      };
      calculationAction
        .updatePortDistanceForContract(portDataObj)
        .then((res) => {
          setLoader(false);
          fetchPortDistance.current = false;
          setPortDistanceResponse(res.data);
          setRealPortDistanceResponse(res?.realData);
          setPortDistancePayloadResponse(res?.payload);
          resolve(res);
        })
        .catch((err) => {
          setLoader(false);
          resolve({});
          toastError(err?.data?.message || "Something went wrong");
        });
    });
  };

  const onFetchPortOperationDistance = (
    reset = false,
    propCalculator = null,
    portCanalChecks = {},
    isSave = false
  ) => {
    let updatedCalculatorData = { ...calculatorData };
    if (propCalculator) {
      updatedCalculatorData = { ...propCalculator };
    }
    const { getPortDistanceString, routeList } =
      convertPortOperationToDistanceString(updatedCalculatorData);
    const { clientQuery = {} } = updatedCalculatorData;
    const {
      eca = false,
      hra = false,
      jwc = false,
      suez = false,
      panama = false,
      singapore = false,
    } = clientQuery;
    const portDataObj = {
      eca,
      hra,
      jwc,
      suez,
      panama,
      singapore,
      routeOverride: false,
      routeList: routeList,
      portList: getPortDistanceString,
      contractId: id || routeId,
      getGeometry: false,
    };
    let request = "";

    // change port selection the query as well
    // onChangePortCanalInQueryState(portCanalChecks);

    if (reset) request = calculationAction.resetPortDistanceForContract({ contractId: id || routeId });
    else request = calculationAction.updatePortDistanceForContract(portDataObj);

    if (!loader) setLoader(true, "Recalculating port distances...");
    request
      .then((res) => {
        setLoader(false);
        setPortDistanceResponse(res.data);
        setRealPortDistanceResponse(res?.realData);
        setPortDistancePayloadResponse(res?.payload);
        if (reset) {
          updatedCalculatorData = {
            ...updatedCalculatorData,
            clientQuery: {
              ...updatedCalculatorData.clientQuery,
              portToPortDistance: {
                ...updatedCalculatorData.clientQuery.portToPortDistance,
                output: res.data,
              },
            },
          }
        }
        let realData = reset ? JSON.parse(JSON.stringify(res.data)) : res.realData;
        const newPortOperations = addPortDistanceToOperations(res.data, [
          ...updatedCalculatorData.portOperation,
        ], realData, false, reset);
        sendCalculationRequest({
          ...updatedCalculatorData,
          clientQuery: {
            ...updatedCalculatorData.clientQuery,
            portToPortDistanceReal: {
              payload: res.payload,
              output: realData,
            },
            portToPortDistance: {
              payload: res.payload,
              output: res.data,
            },
          },
          portOperation: newPortOperations,
          portDistanceResponse: res.data,
          autoSave: isSave,
        });
      })
      .catch((err) => setLoader(false));
  };
  const onChangeBunkerScrubber = (index, e) => {
    const { name = "", value = "" } = e.target;
    let newPortOperation = [...calculatorData?.portOperation];
    newPortOperation[index].cargoDetails[name] = Number(value);
    setCalculatorData({ ...calculatorData, portOperation: newPortOperation });
  };

  const onChangeSyncBunker = (checked) => {
    let updatedClientQuery = { ...calculatorData.clientQuery };

    setSyncBunker(checked);

    if (updatedClientQuery.customerCargo) {
      updatedClientQuery.customerCargo = {
        ...updatedClientQuery.customerCargo,
        fuelPriceOverridden: checked,
        ...(!checked ? { fuelCalculationMethod: "DEFAULT" } : {})
      };
    } else {
      updatedClientQuery.fuelPriceOverridden = checked;
      if (!checked) {
        updatedClientQuery.fuelCalculationMethod = "DEFAULT";
      }
    }

    setCalculatorData({
      ...calculatorData,
      clientQuery: updatedClientQuery,
    });
  };
  const sendCalculatorResponse = (modifiedData = {}) => {
    return new Promise((resolve, reject) => {
      try {
        // Early return if no fleet list
        if (!modifiedData?.fleetList?.length) {
          return resolve({});
        }

        // Process cargo list - preserve cargoDetails structure
        const updatedCargoList = (modifiedData.cargoList || []).map(
          (cargoDetails = {}) => {
            // Don't destructure cargoDetails if it exists, just copy it
            const cargoDetailObj = cargoDetails.cargoDetails || {};
            const { _id, ...restCargoMainDetails } = cargoDetails;
            return {
              ...restCargoMainDetails,
              cargoDetails: { ...cargoDetailObj }, // Preserve the original structure
            };
          }
        );

        // Process client query
        const clientQuery = modifiedData.clientQuery || {};
        const {
          _id,
          cargoList: queryCargoList,
          createdUser,
          lastModifiedUser,
          userId,
          calculationFormat,
          __v,
          createdAt,
          updatedAt,
          isCalculate,
          ...restClientQuery
        } = clientQuery;

        const updatedClientQuery = {
          ...restClientQuery,
          cargoList: null,
        };

        // Process fleet list
        const updatedFleetListData = (modifiedData.fleetList || []).map(
          (fleetDetails = {}, index) => {
            const vesselDetails = fleetDetails?.vessel
              ? JSON.parse(fleetDetails.vessel)
              : {};

            const {
              _id: parseVesselId,
              userId: parseVesselUserId,
              createdUser: parseVesselCreatedUser,
              lastModifiedUser: parseVesselModifiedUser,
              vesselExtraDetails,
              __v: parseVessel__v,
              createdAt,
              createdDate,
              lastModifiedDate,
              pattern,
              updatedAt,
              vesselLabel,
              vesselAHL,
              vesselCO2,
              vesselCountry,
              vesselGrabs,
              vesselIceClass,
              vesselIMO,
              vesselLdnConsmMGO1,
              vesselLdnConsmMGO2,
              vesselLightShip,
              vesselMMSI,
              vesselType,
              vesselSource,
              vesselName,
              ...parseVesselDetails
            } = vesselDetails;

            const {
              _id: fleetId,
              vesselId: fleetVesselId,
              createdUser: fleetCreatedUser,
              organizationId,
              userId: fleetUserId,
              lastModifiedUser: fleetLastModifiedUser,
              vesselUniqueId = uuidv4(), // Default if not provided
              __v: fleet__v,
              ...restFleetDetails
            } = fleetDetails;

            return {
              ...restFleetDetails,
              vessel: JSON.stringify({
                id: vesselUniqueId,
                ...parseVesselDetails,
                system: true,
              }),
              vesselId: vesselUniqueId,
            };
          }
        );

        // Process cargo extra details - preserve cargoDetails structure
        const updatedCargoExtraDetails = (
          modifiedData.cargoExtraDetails || []
        ).map((cargoextraDetails = {}) => {
          // Don't destructure cargoDetails if it exists, just copy it
          const extraCargoDetails = cargoextraDetails.cargoDetails || {};
          const { _id, ...restCargoMainDetails } = cargoextraDetails;
          return {
            ...restCargoMainDetails,
            cargoDetails: { ...extraCargoDetails }, // Preserve the original structure
          };
        });

        const calculationData = {
          id: id || routeId,
          autoSave: modifiedData.autoSave || false,
          cargoExtraDetails: updatedCargoExtraDetails,
          cargoList: updatedCargoList,
          clientQuery: updatedClientQuery,
          fleetList: updatedFleetListData,
        };

        calculationAction
          .estimateContractcargoPrice(calculationData)
          .then((res) => resolve(res))
          .catch((err) => {
            console.error("Calculation error:", err);
            toastError(err?.data?.message || "Something went wrong");
            resolve({});
          });
        calculationAction
          .estimateContractcargoPriceDetailed(calculationData)
          .then((res) => resolve(res))
          .catch((err) => {
            console.error("Calculation error:", err);
            toastError(err?.data?.message || "Something went wrong");
            resolve({});
          });
      } catch (error) {
        console.error("Error in sendCalculatorResponse:", error);
        toastError("An unexpected error occurred");
        resolve({});
      }
    });
  };
  const onChangeFleetRowSelect = async (
    fleet = {},
    resultCalculatorData = null,
    changeVessel = false,
    isPortDistanceChanged = false
  ) => {
    let updatedCalculatorData = {};
    if (resultCalculatorData) updatedCalculatorData = resultCalculatorData;
    else updatedCalculatorData = { ...calculatorData };
    let commencePort = (fleet && fleet.port) || "";
    let fleetFuelType =
      (fleet && fleet.vessel && JSON.parse(fleet.vessel)) || {};
    fleetFuelType = fleetFuelType.fuelType || "TYPE0";
    let portOperation = [...updatedCalculatorData.portOperation];

    const portToPortOperationResultMap =
      (fleet && fleet.portToPortOperationResultMap) || [];
    portOperation = portOperation.map((operation, index) => {
      const selectedResultMap = portToPortOperationResultMap[index] || {};
      const removeDistanceFromResultMap = ({
        distanceECA = "",
        distanceNormal = "",
        ...rest
      }) => {
        return { ...rest };
      };
      if (index !== 0) commencePort = (operation && operation.port) || "";
      let isTermExists = termsCoEfficientTable[0];
      if (operation.terms) {
        isTermExists = termsCoEfficientTable.find(
          (item) => item.label === operation.terms
        );
      }
      let cargoDetails = { ...operation.cargoDetails };

      if (index === 0) {
        const currentType = fleetFuelType.replace("TYPE", "");
        const {
          bnkDelhs = 0,
          bnkDells = 0,
          bnkDelmgo = 0,
          bnkPriceDeliveryhs = 0,
          bnkPriceDeliveryls = 0,
          bnkPriceDeliverymgo = 0,
        } = fleet;
        cargoDetails = {
          ...cargoDetails,
          bunkerSuppliedHSFO: bnkDelhs,
          bunkerSuppliedLSFO: bnkDells,
          bunkerSuppliedMGO: bnkDelmgo,
          [`fuelPriceType${currentType}Hsfo`]: bnkPriceDeliveryhs,
          [`fuelPriceType${currentType}Lsfo`]: bnkPriceDeliveryls,
          [`fuelPriceType${currentType}Mgo`]: bnkPriceDeliverymgo,
        };
      }
      return {
        ...operation,
        ...removeDistanceFromResultMap(selectedResultMap),
        cargoDetails,
        port: commencePort,
        terms: isTermExists.label,
        factor: isTermExists.value,
      };
    });

    if (!isPortDistanceChanged) {
      let portDistanceRes = portDistanceResponse;
      if (fetchPortDistance.current) {
        portDistanceRes = await onFetchAndSetIntitalPortDistance(
          updatedCalculatorData
        );
      }
      portOperation = addPortDistanceToOperations(portDistanceRes, [
        ...portOperation,
      ]);
    }
    // add post distance to selected fleet as well
    fleet = addPortDistanceToSelectedFleet(portOperation, fleet);

    if (changeVessel || !selectedVessels._id) {
      setSelectedVessels(fleet);
    }

    setCalculatorData({
      ...updatedCalculatorData,
      clientQuery: {
        ...updatedCalculatorData.clientQuery,
        fuelType: fleetFuelType,
      },
      fleetList: updatedCalculatorData.fleetList.map((singleFleet) => {
        if (singleFleet._id === fleet._id) return fleet;
        else return singleFleet;
      }),
      portOperation,
    });
  };
  const onClickCalculateAndSave = async () => {
    await sendCalculationRequest({ ...calculatorData, autoSave: true });
  };

  const sendCalculationRequest = async (sendData) => {
    let portDistanceRes = sendData?.portDistanceResponse || portDistanceResponse;
    let realData = sendData?.clientQuery?.portToPortDistanceReal?.output || realPortDistanceResponse;
    let payload = sendData?.clientQuery?.portToPortDistanceReal?.payload || portDistancePayloadResponse;
    if (fetchPortDistance.current) {
      const { data, realData: realDataRes, payload: payloadRes } = await onFetchAndSetIntitalPortDistance(sendData);
      portDistanceRes = data;
      realData = realDataRes;
      payload = payloadRes;
    }

    sendData = {
      ...sendData,
      clientQuery: {
        ...sendData.clientQuery,
        portToPortDistanceReal: {
          output: realData,
          payload,
        },
        portToPortDistance: {
          output: portDistanceRes,
          payload,
        },
      },
      portOperation: addPortDistanceToOperations(portDistanceRes, [
        ...sendData.portOperation,
      ],
        realData,
      ),
    };
    let fleetSelected = {};
    const updatedFleedIds = sendData.fleetList.map((fleetDetails) => ({
      ...fleetDetails,
      vesselUniqueId: uuidv4(),
    }));

    let modifiedData = {
      cargoList: sendData.portOperation.filter((item) => !item.isExtra),
      cargoExtraDetails: sendData.portOperation.filter(
        (item) => !!item.isExtra
      ),
      fleetList: cloneDeep(updatedFleedIds),
      clientQuery: {
        ...sendData.clientQuery,
        ...(sendData.clientQuery.customerCargo && {
          customerCargo: {
            ...sendData.clientQuery.customerCargo,
            cargoList: sendData.portOperation,
          },
        }),
        calculationFormat: sendData.portOperation
          .map((item) => item._id)
          .join(","),
      },
      autoSave: false,
    };

    await calculationValidation(modifiedData, selectedVessels);

    if (!loader) setLoader(true, "Calculating pricing and costs...");
    const res = await sendCalculatorResponse(modifiedData);
    setLoader(false);

    const fleetData = fleetWithCalculatorDataMapping(
      cloneDeep(updatedFleedIds),
      res?.data
    );

    if (selectedVessels && selectedVessels._id) {
      fleetSelected =
        fleetData.find((item) => item._id === selectedVessels._id) || {};
    } else {
      fleetSelected = fleetData[0];
    }

    // Create the updated calculator data
    const updatedCalculatorData = {
      ...sendData,
      fleetList: fleetData,
      clientQuery: {
        ...sendData.clientQuery,
        calculationFormat: modifiedData.clientQuery.calculationFormat,
      },
    };

    // Update the state
    setCalculatorData(updatedCalculatorData);

    onChangeFleetRowSelect(fleetSelected, updatedCalculatorData, true, true);

    const {
      __v,
      version,
      system,
      createdUser,
      vesselId,
      vesselName,
      userId,
      lastModifiedUser,
      lastModifiedDate,
      ...restClientQuery
    } = updatedCalculatorData.clientQuery;

    let newUpdatedQuery = {
      ...restClientQuery,
      createdUser: createdUser?._id,
    };
    const isCargoCargo = rawEstimateContract?.cargoContractDetails?.contractType === "cargo-cargo";
    if (newUpdatedQuery.customerCargo || isCargoCargo) {
      newUpdatedQuery.customerCargo = {
        ...(newUpdatedQuery.customerCargo || {}),
        cargoList: sendData.portOperation,
      };
      delete newUpdatedQuery.cargoList;
    } else {
      newUpdatedQuery.cargoList = sendData.portOperation;
    }

    const newUpdatedFleet = { ...fleetSelected };

    if (sendData.autoSave) {
      saveAllResultUpdatedData({
        newUpdatedFleet,
        newUpdatedQuery,
      });
    }
  };

  const saveAllResultUpdatedData = ({ newUpdatedQuery, newUpdatedFleet }) => {
    const updatedBy = {
      userId: getCurrentUserId(),
      updatedDate: new Date(),
    }
    calculationAction.updateEstimateCost({
      contractId: id || routeId,
      newUpdatedQuery,
      newUpdatedFleet,
      isOperation: true,
      updatedBy,
      isRevised: true,
    })
      .then((res) => {
        if (res?.success) {
          toastSuccess("Calculation updated and saved successfully!");
          setIsRevised(true);
        }
      })
      .catch((err) => {
        setLoader(false);
        toastError(err?.data?.message);
      });
  };
  const onDeleteOperations = (index, cid, opIndex) => {
    setLoader(true, "Deleting operation...");
    fetchPortDistance.current = true;
    calculationAction
      .deleteCargoFromEstimateById({
        contractId: id || routeId,
        cargoId: opIndex,
        contractType: rawEstimateContract?.cargoContractDetails?.contractType,
      })
      .then((res) => {
        setLoader(false);
        let portOperation = [...calculatorData.portOperation];
        portOperation.splice(index, 1);
        const updatedSelectedQuery = {
          ...calculatorData?.clientQuery,
          calculationFormat: res.data?.cargoContractDetails?.calculationFormat,
        };

        setCalculatorData({
          ...calculatorData,
          portOperation,
          clientQuery: updatedSelectedQuery,
        });
      })
      .catch((err) => setLoader(false));
  };

  const onAddOperations = (requiredData = {}) => {
    setLoader(true, "Adding new operation...");
    fetchPortDistance.current = true;
    calculationAction
      .addCargoForEstimate({
        details: {
          ...initialCreatePortOperation,
          ...requiredData,
        },
        contractId: id || routeId,
        addIndex: openAddOperationIndex,
      })
      .then((response) => {
        const updatedSelectedQuery = {
          ...calculatorData,
          calculationFormat: response.data?.calculationFormat,
        };
        setLoader(false);
        const portOperation = placeAddedOperation(
          calculatorData.portOperation,
          response?.data?.cargoDetails?.cargoList || [],
          openAddOperationIndex
        );

        // Properly update calculatorData state
        setCalculatorData((prev) => ({
          ...prev,
          clientQuery: updatedSelectedQuery.clientQuery,
          portOperation,
        }));

        // Create the payload for sendCalculationRequest
        const updatedCalculatorData = {
          ...calculatorData,
          clientQuery: updatedSelectedQuery.clientQuery,
          portOperation,
        };

        sendCalculationRequest(updatedCalculatorData);
      })
      .catch((err) => {
        setLoader(false);
      });
  };
  const onChangePortOperations = (index, e, cargoUpdate = false) => {
    let { value = "", name = "" } = e.target;
    let portOperation = [...calculatorData.portOperation];

    if (name === "terms") {
      const termFactor = termsCoEfficientTable.find(
        (item) => item.label === value
      );
      portOperation[index]["terms"] = value;
      portOperation[index]["factor"] = (termFactor && termFactor.value) || 0;
    } else if (cargoUpdate) {
      if (!portOperation[index].cargoDetails) {
        portOperation[index].cargoDetails = {};
      }
      portOperation[index].cargoDetails[name] = value;
    } else {
      portOperation[index][name] = value;
    }

    let updatedCalculatorData = { ...calculatorData, portOperation };

    if (
      !cargoUpdate &&
      updatedCalculatorData?.clientQuery?.portToPortDistance?.output &&
      portOperation[index - 1] &&
      portOperation[index]?.port
    ) {
      const key = `${portOperation[index - 1]?.port}_${portOperation[index].port}`;
      if (updatedCalculatorData.clientQuery.portToPortDistance.output[key]) {
        updatedCalculatorData.clientQuery.portToPortDistance.output[key][name] = value;
      }
    }
    if (name === "distanceNormal" || name === "distanceECA") {
      const updateData = {
        distEca: portOperation[index].distanceECA,
        distNormal: portOperation[index].distanceNormal,
        id: portOperation[index]._id,
      };
      const saveData = {
        distEca: portOperation[index].distanceECA,
        distNormal: portOperation[index].distanceNormal,
        openingPort:
          (portOperation[index - 1] && portOperation[index - 1]["port"]) || "",
        endingPort: portOperation[index]["port"] || "",
      };
      delayUpdateAndSaveOperation({
        updateData,
        saveData,
        updatedCalculatorData,
      });
    }
    setCalculatorData(updatedCalculatorData);
  };
  const calculationErrors = useMemo(() => {
    let errors = [];
    if (
      selectedVessels &&
      calculatorData.portOperation.length &&
      calculatorData.fleetList.length
    ) {
      errors = calculationValidation(calculatorData, selectedVessels);
    }
    return errors;
  }, [calculatorData, selectedVessels]);
  const onClickCalculate = () => {
    sendCalculationRequest({ ...calculatorData, autoSave: false });
  };

  const onSetOpenMap = () => {
    if (id || routeId) {
      window.open(`/map/${calculatorData.clientQuery?._id}`);
    }
  };

  const onClickCopyToEstimate = () => {
    setEstimationCopyModelOpen(true);
  };

  const handleCopyToEstimation = async () => {
    try {
      const payload = {
        assignedTo: getCurrentUserId(),
        operationAccess: "private",
      };
      await calculationAction.updateEstimateContract({ _id: id || routeId }, payload);
      setEstimationCopyModelOpen(false);
      toastSuccess("Operation Assigned to you successfully!");
    } catch (error) {
      toastError("Error while Assigning operation!");
      console.error("Error while Assigning operation:", error);
    }
  };

  const onClickEditCargoContract = () => {
    setEditCargoContractModelOpen(true);
    const data = rawEstimateContract?.cargoContractDetails;
    setCargoFormData({ ...data, cargoList: data?.cargoDetails?.cargoList });
    setPrevAttachments({
      attachments: [...(data?.attachments || [])],
      textContract: data?.textContract,
    });
  };

  const onClickVesselCargoContract = () => {
    setEditVesselContractModelOpen(true);
    const data = rawEstimateContract?.vesselContractDetails;
    setVesselFormData(data);
    setPrevAttachments({
      attachments: [...(data?.attachments || [])],
      textContract: data?.textContract,
    });
  };

  const handleUpdateCargoContract = () => {
    const { _id, cargoList, actualCargoContract, operationCargoContract, ...payload } = cargoFormData;
    const cpDate = payload.cpDate || payload.contractDate || payload.cp_date || moment().format("YYYY-MM-DD");
    const finalPayload = {
      ...payload,
      cpDate,
      cargoDetails: {
        ...payload.cargoDetails,
        customerCargo: {
          ...(payload.cargoDetails?.customerCargo || {}),
          cargoList: cargoList,
        },
      },
    };
    if (!payload.contractName) {
      toastError("Contract name is required.");
      return;
    }
    const formPayload = new FormData();

    if (cargoTextContract) {
      const fileType = cargoTextContract.type || "application/octet-stream";
      const fileName = cargoTextContract.name || "contract";

      const textBlob = new Blob([cargoTextContract], { type: fileType });
      const textFile = new File([textBlob], fileName, { type: fileType });

      formPayload.append("files", textFile);
      formPayload.append(
        "textContractMetadata",
        JSON.stringify({ fileType: "textContract" })
      );
    }

    // Append attachments if available
    if (cargoAttachments?.length) {
      cargoAttachments.forEach((file) => {
        formPayload.append("files", file);
      });
    }

    // Append form data
    formPayload.append(
      "data",
      JSON.stringify({
        ...finalPayload,
        cpDate,
        isContract: true,
        attachments: prevAttachments.attachments,
        textContract: prevAttachments.textContract,
        organizationId,
      })
    );

    calculationAction
      .updateEstimateCargo({ _id: id || routeId }, formPayload)
      .then(() => {
        setEditCargoContractModelOpen(false);
        setCargoAttachments([]);
        setCargoTextContract("");
        setPrevAttachments({
          attachments: [],
          textContract: "",
        });
        getInitialData(id || routeId);
        toastSuccess("Cargo Contract Updated successfully!!");
      })
      .catch((err) => {
        toastError(err.message);
      });
  };
  const removeCargoAttachment = (index) => {
    setCargoAttachments((prev) => (Array.isArray(prev) ? prev : []).filter((_, i) => i !== index));
  };
  const handleCargoContractInputChange = (e) => {
    const { name, value } = e.target;
    setCargoFormData({
      ...cargoFormData,
      [name]: value,
    });
  };

  const handleCargoTextContractUpload = (e) => {
    if (e.target.files[0]) {
      setCargoTextContract(e.target.files[0]);
    }
  };

  const handleCargoContractAttachmentUpload = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      const validFiles = newFiles.filter(
        (file) => file.size <= 5 * 1024 * 1024
      );

      if (validFiles.length !== newFiles.length) {
        alert("Some files exceed the 5 MB size limit and were not added.");
      }

      setCargoAttachments((prev) => [...(Array.isArray(prev) ? prev : []), ...validFiles]);
    }
  };

  const handleUpdateVesselContract = () => {
    const { _id, ...payload } = vesselFormData;
    if (!payload.contractName) {
      toastError("Contract name is required.");
      return;
    }
    const formPayload = new FormData();

    if (vesselTextContract) {
      const fileType = vesselTextContract.type || "application/octet-stream";
      const fileName = vesselTextContract.name || "contract";

      const textBlob = new Blob([vesselTextContract], { type: fileType });
      const textFile = new File([textBlob], fileName, { type: fileType });

      formPayload.append("files", textFile);
      formPayload.append(
        "textContractMetadata",
        JSON.stringify({ fileType: "textContract" })
      );
    }

    // Append attachments if available
    if (vesselAttachments?.length) {
      vesselAttachments.forEach((file) => {
        formPayload.append("files", file);
      });
    }

    // Append form data
    formPayload.append(
      "data",
      JSON.stringify({
        ...payload,
        attachments: prevAttachments.attachments,
        textContract: prevAttachments.textContract,
        organizationId,
      })
    );

    calculationAction
      .updateVesselContract({ _id }, formPayload)
      .then(() => {
        setEditVesselContractModelOpen(false);
        setVesselAttachments([]);
        setVesselTextContract("");
        setPrevAttachments({
          attachments: [],
          textContract: "",
        });
        getInitialData(id || routeId);
        toastSuccess("Vessel Contract Updated successfully!!");
      })
      .catch((err) => {
        toastError(err.message);
      });
  };
  const removeVesselAttachment = (index) => {
    setVesselAttachments((prev) => (Array.isArray(prev) ? prev : []).filter((_, i) => i !== index));
  };
  const handleVesselContractInputChange = (e) => {
    const { name, value } = e.target;
    setVesselFormData({
      ...vesselFormData,
      [name]: value,
    });
  };

  const handleVesselTextContractUpload = (e) => {
    if (e.target.files[0]) {
      setVesselTextContract(e.target.files[0]);
    }
  };

  const handleVesselContractAttachmentUpload = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      const validFiles = newFiles.filter(
        (file) => file.size <= 5 * 1024 * 1024
      );

      if (validFiles.length !== newFiles.length) {
        alert("Some files exceed the 5 MB size limit and were not added.");
      }

      setVesselAttachments((prev) => [...(Array.isArray(prev) ? prev : []), ...validFiles]);
    }
  };

  return (
    <>
      <Grid className="calculator-section px-2.5 pt-1 pb-2">
        <Grid item xs={12} className="main-content-wrapper-inner">
          <div className="quick-menu-bar items-center grid grid-cols-6 justify-between pb-1 m-0">
            <div className="col-span-2 w-fit">
              {id && <CustomTabs
                tabs={propsTabs}
                active={active}
                onChange={handleMainTabChange}
              />}
            </div>
            <div className="col-span-4">
              <ActionButtons
                onSetOpenMap={onSetOpenMap}
                onClickCalculate={onClickCalculate}
                onClickCalculateAndSave={() => setShowSaveWarningModal(true)}
                isPublic={!IsEditable && !isFromSavedContracts}
                isOperationPage
                onClickCopyToEstimate={onClickCopyToEstimate}
                isFromSavedContracts={isFromSavedContracts}
              />
            </div>
          </div>
          <Grid container spacing={1}>
            {/* Cargo Details */}
            <Grid item xs={12} sm={6} md={4} lg={2}>
              <div className="upper-section-grid bg-white border border-[#cbd5e1] min-h-full">
                <AccountCargoDetails
                  isFromSingleVesselCalcy
                  calculatorData={calculatorData}
                  setLoader={setLoader}
                  getInitialData={getInitialData}
                  isContractEstimate
                  IsEditable={IsEditable}
                  onClickEditCargoContract={onClickEditCargoContract}
                />
              </div>
            </Grid>

            {/* Vessel Details */}
            <Grid item xs={12} sm={6} md={8} lg={4}>
              <div className="upper-section-grid bg-white border border-[#cbd5e1] min-h-full">
                <CalculatorVesselDetails
                  setLoader={setLoader}
                  setSelectedVessels={setSelectedVessels}
                  selectedVessels={selectedVessels}
                  calculatorData={calculatorData}
                  setCalculatorData={setCalculatorData}
                  onChangeHandler={onChangeSelectedVessel}
                  fleetCheckbox={fleetCheckbox}
                  setFleetCheckbox={setFleetCheckbox}
                  isContractEstimate
                  onClickEditVesselContract={onClickVesselCargoContract}
                />
              </div>
            </Grid>

            {/* Margin and Allowances */}
            <Grid item xs={12} sm={6} md={4} lg={2}>
              <div className="upper-section-grid bg-white border border-[#cbd5e1] min-h-full">
                <MarginAndAllowances
                  isFromSingleVesselCalcy
                  onChangeSelectedVessel={onChangeSelectedVessel}
                  selectedVessels={selectedVessels}
                  setSelectedVessels={setSelectedVessels}
                  setMarginModal={setMarginModal}
                  calculatorData={calculatorData}
                  setCalculatorData={setCalculatorData}
                  syncBunker={syncBunker}
                  setSyncBunker={setSyncBunker}
                  setSupplyModal={setSupplyModal}
                  onChangeSyncBunker={onChangeSyncBunker}
                  isOverride={isOverride}
                  setIsOverride={setIsOverride}
                  isContractEstimate
                />
              </div>
            </Grid>

            {/* Expenses */}
            <Grid item xs={12} sm={6} md={4} lg={2}>
              <div className="upper-section-grid bg-white border border-[#cbd5e1] min-h-full">
                <Expenses
                  isFromSingleVesselCalcy
                  onChangeSelectedVessel={onChangeSelectedVessel}
                  selectedVessels={selectedVessels}
                  calculatorData={calculatorData}
                  setCalculatorData={setCalculatorData}
                  setShowExpensesModal={setShowExpensesModal}
                  openSplitHireModal={() => setSplitHireModal(true)}
                />
              </div>
            </Grid>

            {/* Results */}
            <Grid item xs={12} sm={6} md={4} lg={2}>
              <div className="upper-section-grid bg-white border border-[#cbd5e1] min-h-full">
                <Result
                  selectedVessels={selectedVessels}
                  calculationErrors={calculationErrors}
                />
              </div>
            </Grid>

            <div className="w-full mt-2 mb-1">

              <div className="flex flex-wrap justify-between items-end gap-y-1 relative z-10 w-full">
                <div className="flex space-x-1 items-end">
                  {tabs.map((tab, index) => {
                    const isActive = activeTab === index;
                    return (
                      <button
                        key={index}
                        onClick={() => handleTabChange(index)}
                        className={`
                  group relative px-3 sm:px-5 py-1 text-xs font-semibold whitespace-nowrap rounded-t-lg transition-all duration-200 ease-out focus:outline-none
                  ${isActive
                            ? 'bg-[#313C4C] text-white translate-y-[1px]'
                            : 'bg-slate-200/50 text-slate-500 hover:bg-slate-200 hover:text-slate-700 border-x border-t border-transparent pb-1.5'
                          }
                `}
                      >
                        {tab}
                      </button>
                    );
                  })}
                </div>

                {activeTab === 1 && (
                  <div className="flex flex-wrap items-center gap-x-4 gap-y-1 mb-1 mr-0 sm:mr-4 px-2 sm:px-0 w-full sm:w-auto text-[11px]">
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span style={{ marginRight: "6px", fontSize: "11px", fontWeight: 500, color: "#000000" }}>TC Adcom %:</span>
                      <input
                        type="number"
                        name="tcAdcom"
                        className="focus:outline focus:outline-[1.5px] focus:outline-[#d97706] focus:-outline-offset-[1.5px] focus:bg-white"
                        style={{
                          width: "60px",
                          border: "1px solid #a3b8cb",
                          height: "19px",
                          padding: "0 4px",
                          fontSize: "11px",
                          fontWeight: 500,
                          color: "#000000",
                          borderRadius: "2px",
                          outline: "none"
                        }}
                        value={calculatorData?.clientQuery?.tcAdcom || ""}
                        onChange={onChangeClientQuery}
                      />
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <label style={{ fontSize: "11px", fontWeight: 500, color: "#000000", marginRight: "4px", margin: 0, cursor: "pointer" }}>
                        Allow Fuel Price Adjustments
                      </label>
                      <Switch
                        size="small"
                        checked={syncBunker}
                        onChange={(e) => onChangeSyncBunker(e.target.checked)}
                        name="checkedA"
                        color="primary"
                        style={{ margin: 0 }}
                      />
                    </div>
                  </div>
                )}
              </div>

              {/* 3. Elevated Content Container */}
              <div className=" shadow-[0_8px_30px_rgb(0,0,0,0.04)] relative z-0 overflow-hidden">

                <SwipeableViews
                  index={activeTab}
                  onChangeIndex={handleSwipeChange}
                  className="w-full"
                  animateHeight
                  action={(actions) => {
                    swipeableActions.current = actions;
                  }}
                >
                  <div className="p-0">
                    <div className="middle-section-grid">
                      <PortOperations
                        sendCalculationRequest={sendCalculationRequest}
                        onChangePortOperations={onChangePortOperations}
                        calculatorData={calculatorData}
                        setCalculatorData={setCalculatorData}
                        onAddOperations={onAddOperations}
                        onDeleteOperations={onDeleteOperations}
                        onChangeSyncBunker={onChangeSyncBunker}
                        onFetchPortOperationDistance={onFetchPortOperationDistance}
                        fetchPortDistance={fetchPortDistance}
                        openAddOperation={openAddOperation}
                        setOpenAddOperation={setOpenAddOperation}
                        setOpenAddOperationindex={setOpenAddOperationindex}
                        isContractEstimate
                        disableEdit={!IsEditable}
                        onClickCalculateAndSave={() => setShowSaveWarningModal(true)}
                      />
                    </div>
                  </div>
                  <div className="p-0">
                    <div>
                      <BunkerSupplyMarginAllowance
                        portOperation={calculatorData.portOperation}
                        syncBunker={syncBunker}
                        setSyncBunker={setSyncBunker}
                        clientQuery={selectedVessels?.clientQuery}
                        onChangeBunkerScrubber={onChangeBunkerScrubber}
                        selectedVessels={selectedVessels}
                        onChangeSyncBunker={onChangeSyncBunker}
                        onChangeSelectedVessel={onChangeSelectedVessel}
                        onChangePortOperations={onChangePortOperations}
                        isOverride={isOverride}
                        setIsOverride={setIsOverride}
                        calculatorData={calculatorData}
                        setCalculatorData={setCalculatorData}
                      />
                    </div>
                  </div>
                </SwipeableViews>
              </div>
            </div>

            {/* Remarks */}
            <Grid item xs={12} md={6}>
              <div className="lower-section-grid">
                <div className="selected-vessel-remark">
                  <p>
                    Remarks:
                    <span>
                      {(selectedVessels && selectedVessels.remark) || ""}
                    </span>
                  </p>
                </div>
              </div>
            </Grid>
          </Grid>

        </Grid>
        <CustomAddModal
          open={estimationCopyModelOpen}
          maxWidth="md"
          saveLabel="Assign to Me"
          handleClose={() => setEstimationCopyModelOpen(false)}
          onSubmitConfirm={handleCopyToEstimation}
        >
          <div className="px-6 py-8 text-center">
            <div className="mx-auto flex items-center justify-center rounded-full bg-blue-100 mb-6">
              <InfoTwoTone className="h-16 w-16" color="primary" />
            </div>

            <h3 className="text-xl font-medium text-gray-900 mb-2">
              Are you sure you want to assign this operation to yourself?
            </h3>

            <div className="bg-rose-50 border border-rose-200 rounded-md p-4 mb-4">
              <p className="text-darkRed text-sm">
                Note: You are about to take ownership of the selected operation
              </p>
            </div>
          </div>
        </CustomAddModal>
        <CustomShowModal
          open={splitHireModal}
          handleClose={() => setSplitHireModal(false)}
          maxWidth="xs"
          title="Split Hire"
        >
          <SplitHireModal
            addNewSplitHire={addRow}
            selectedSplitHire={calculatorData.fleetList?.[0]}
            onChangeSplitHire={onChangeSplitHire}
          />
        </CustomShowModal>
        {IsEditable ? (
          <CustomAddModal
            open={editCargoContractModelOpen}
            title={"Update Cargo Contract"}
            maxWidth="md"
            saveLabel={"Update"}
            handleClose={() => setEditCargoContractModelOpen(false)}
            onSubmitConfirm={handleUpdateCargoContract}
          >
            <CreateCargoContractForm
              formData={cargoFormData}
              setFormData={setCargoFormData}
              handleChange={handleCargoContractInputChange}
              removeAttachment={removeCargoAttachment}
              textContract={cargoTextContract}
              handleTextContractUpload={handleCargoTextContractUpload}
              handleAttachmentUpload={handleCargoContractAttachmentUpload}
              attachments={cargoAttachments}
              setTextContract={setCargoTextContract}
              isEditing
              prevAttachments={prevAttachments}
              setPrevAttachments={setPrevAttachments}
            />
          </CustomAddModal>
        ) : (
          <CustomShowModal
            open={editCargoContractModelOpen}
            title={"View Cargo Contract"}
            maxWidth="md"
            handleClose={() => setEditCargoContractModelOpen(false)}
          >
            <CreateCargoContractForm
              formData={cargoFormData}
              setFormData={setCargoFormData}
              handleChange={handleCargoContractInputChange}
              removeAttachment={removeCargoAttachment}
              textContract={cargoTextContract}
              handleTextContractUpload={handleCargoTextContractUpload}
              handleAttachmentUpload={handleCargoContractAttachmentUpload}
              attachments={cargoAttachments}
              setTextContract={setCargoTextContract}
              prevAttachments={prevAttachments}
              setPrevAttachments={setPrevAttachments}
            />
          </CustomShowModal>
        )}
        {IsEditable ? (
          <CustomAddModal
            open={editVesselContractModelOpen}
            title={"Update Vessel Contract"}
            maxWidth="md"
            saveLabel={"Update"}
            handleClose={() => setEditVesselContractModelOpen(false)}
            onSubmitConfirm={handleUpdateVesselContract}
          >
            <VesselContractForm
              formData={vesselFormData}
              setFormData={setVesselFormData}
              handleChange={handleVesselContractInputChange}
              attachments={vesselAttachments}
              textContract={vesselTextContract}
              removeAttachment={removeVesselAttachment}
              handleTextContractUpload={handleVesselTextContractUpload}
              handleAttachmentUpload={handleVesselContractAttachmentUpload}
              isEditing
              setTextContract={setVesselTextContract}
              prevAttachments={prevAttachments}
              setPrevAttachments={setPrevAttachments}
            />
          </CustomAddModal>
        ) : (
          <CustomShowModal
            open={editVesselContractModelOpen}
            handleClose={() => setEditVesselContractModelOpen(false)}
            title="View Vessel Contract"
            maxWidth="md"
          >
            <VesselContractForm
              formData={vesselFormData}
              setFormData={setVesselFormData}
              handleChange={handleVesselContractInputChange}
              attachments={vesselAttachments}
              textContract={vesselTextContract}
              removeAttachment={removeVesselAttachment}
              handleTextContractUpload={handleVesselTextContractUpload}
              handleAttachmentUpload={handleVesselContractAttachmentUpload}
              setTextContract={setVesselTextContract}
              prevAttachments={prevAttachments}
              setPrevAttachments={setPrevAttachments}
            />
          </CustomShowModal>
        )}
        <CustomShowModal
          open={showExpensesModal}
          handleClose={() => setShowExpensesModal(false)}
          maxWidth="md"
          title="Expenses"
        >
          <DailyExpensesModal
            dailyExpenses={calculatorData?.clientQuery?.dailyExpenses}
            selectedVessels={selectedVessels}
            calculatorData={calculatorData}
            setCalculatorData={setCalculatorData}
          />
        </CustomShowModal>

        <CustomConfirmModal
          open={showSaveWarningModal}
          handleClose={() => setShowSaveWarningModal(false)}
          message="Are you sure you want to save?"
          onSubmitConfirm={() => {
            onClickCalculateAndSave();
            setShowSaveWarningModal(false);
          }}
          type="warning"
          confirmText="Update"
          cancelText="Cancel"
          note={`Any updates made here will automatically reflect in the ${isFromSavedContracts ? "Operations" : "Contracts"} module and impact its calculations`}
        />

        <CustomShowModal
          open={marginModal}
          handleClose={() => setMarginModal(false)}
          maxWidth="sm"
          title="Margin Allowances Table"
        >
          <MarginAllowancesTable
            calculatorData={calculatorData}
            setCalculatorData={setCalculatorData}
          />
        </CustomShowModal>
      </Grid>
    </>
  );
}
